
define('text!app-SearchResults/modules/batBelt/viewCruise.html',[],function () { return '<h1 class="h3_style"><span data-bind="text: TotalResults"></span> cruises</h1>';});

